const VIEW_TYPES = {
  default: "default",
  compact: "compact",
} as const;

export { VIEW_TYPES };
